var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { findParamInLocalStorage } from "ah_utility/fnxUtils";
import { useTranslation } from "react-i18next";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { EXPORT_OPTION_ID, INITIAL_PAGE, INITIAL_PAGE_SIZE, } from "../constants/reportsSummaries.constants";
import { useApiPostExecuteReports } from "../../../fnx/reports/postExecuteReports";
import { useDownloadReport } from "../../../fnx/reports/reportExport";
import { showErrorToast } from "../../../fnx/showError";
import { executeReportsClearData } from "../../../store/reports/actions";
import { getCurrentMonth, getCurrentSemester, getPreviousMonth, getQuarterDates, } from "../../../services/getDates";
import { formattedDateYYMMDD, newFormattedDate } from "../../../utils/date";
export var useReportsSummaries = function () {
    var _a, _b;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _c = useParams(), reportId = _c.reportId, reportDate = _c.reportDate;
    var navState = useLocation().state;
    var clientId = useMemo(function () { var _a; return (_a = findParamInLocalStorage("clientId", "assurehub")) !== null && _a !== void 0 ? _a : ""; }, []);
    var _d = useState(null), htmlData = _d[0], setHtmlData = _d[1];
    var _e = useState(false), dataReady = _e[0], setDataReady = _e[1];
    var _f = useState({
        page: INITIAL_PAGE,
        pageSize: INITIAL_PAGE_SIZE,
        reportTrigger: false,
        exportFormat: null,
        reportName: (navState === null || navState === void 0 ? void 0 : navState.reportName) || "",
        bodyExeReport: {
            id: "",
            includeHtml: (_a = navState === null || navState === void 0 ? void 0 : navState.renderHtml) !== null && _a !== void 0 ? _a : false,
            params: { from: "", to: "", clientId: clientId },
            page: INITIAL_PAGE,
            pageSize: INITIAL_PAGE_SIZE,
        },
    }), state = _f[0], setState = _f[1];
    var _g = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), toast = _g[0], setToast = _g[1];
    var _h = useState([]), columns = _h[0], setColumns = _h[1];
    var _j = useState([]), rows = _j[0], setRows = _j[1];
    var _k = useApiPostExecuteReports(state.reportTrigger, state.bodyExeReport), loadingExecuteReports = _k.loadingExecuteReports, responseExecuteReports = _k.responseExecuteReports, errorExecuteReports = _k.errorExecuteReports;
    var _l = useDownloadReport({
        trigger: state.exportFormat !== null,
        reportBody: state.bodyExeReport,
        format: (_b = state.exportFormat) !== null && _b !== void 0 ? _b : "xlsx",
        filename: state.reportName,
        onFinish: function () { return setState(function (prev) { return (__assign(__assign({}, prev), { exportFormat: null })); }); },
    }), loadingExport = _l.loading, errorExport = _l.error;
    var onClickMonthReport = function (date) {
        var _a, _b;
        var dateMap = {
            currentMonth: getCurrentMonth,
            prevMonth: getPreviousMonth,
            currentQuarter: function () { return getQuarterDates("current"); },
            prevQuarter: function () { return getQuarterDates("previous"); },
            currentSemester: getCurrentSemester,
        };
        var rangeFn = dateMap[date];
        var startDate = "";
        var endDate = "";
        if (rangeFn) {
            (_a = rangeFn(), startDate = _a.startDate, endDate = _a.endDate);
        }
        else if (date.includes("---")) {
            _b = date.split("---"), startDate = _b[0], endDate = _b[1];
        }
        setState(function (prev) { return (__assign(__assign({}, prev), { bodyExeReport: __assign(__assign({}, prev.bodyExeReport), { id: reportId || "", params: { from: startDate, to: endDate, clientId: clientId } }) })); });
    };
    useEffect(function () {
        setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: true })); });
        onClickMonthReport(reportDate || "");
    }, []);
    useEffect(function () {
        if (errorExecuteReports) {
            showErrorToast(errorExecuteReports, setToast, t);
            dispatch(executeReportsClearData());
        }
    }, [errorExecuteReports]);
    useEffect(function () {
        if (errorExport) {
            setToast({
                show: true,
                message: errorExport instanceof Error
                    ? errorExport.message
                    : "Error al descargar el reporte",
                type: typeAlert.error,
            });
            setState(function (prev) { return (__assign(__assign({}, prev), { exportFormat: null })); });
        }
    }, [errorExport]);
    useEffect(function () {
        setDataReady(false);
    }, [state.bodyExeReport]);
    useEffect(function () {
        var _a, _b, _c;
        if (!responseExecuteReports)
            return;
        if (((_a = responseExecuteReports === null || responseExecuteReports === void 0 ? void 0 : responseExecuteReports.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var firstItem = (_b = responseExecuteReports === null || responseExecuteReports === void 0 ? void 0 : responseExecuteReports.data) === null || _b === void 0 ? void 0 : _b[0];
            var columnOrder_1 = Object.keys(firstItem);
            var parsedColumns = columnOrder_1.map(function (key) {
                var base = {
                    field: key,
                    headerName: key
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, function (str) { return str.toUpperCase(); }),
                    width: 200,
                };
                if (key.toLowerCase().includes("fecha")) {
                    return __assign(__assign({}, base), { valueFormatter: function (params) {
                            return newFormattedDate(params.value, false, "/");
                        } });
                }
                return base;
            });
            var parsedRows = (_c = responseExecuteReports === null || responseExecuteReports === void 0 ? void 0 : responseExecuteReports.data) === null || _c === void 0 ? void 0 : _c.map(function (item, index) {
                var _a;
                var row = __assign({}, item);
                columnOrder_1.forEach(function (col) {
                    if (!(col in row))
                        row[col] = null;
                });
                if (row["Prima"]) {
                    var prima = parseFloat(row["Prima"]);
                    if (!isNaN(prima)) {
                        row["Prima"] = "RD$ ".concat(prima.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }));
                    }
                }
                return __assign({ id: (_a = item.Cotizacion) !== null && _a !== void 0 ? _a : "row-".concat(index) }, row);
            });
            setColumns(parsedColumns);
            setRows(parsedRows);
        }
        if (responseExecuteReports === null || responseExecuteReports === void 0 ? void 0 : responseExecuteReports.html) {
            setHtmlData(responseExecuteReports.html);
        }
        setDataReady(true);
        dispatch(executeReportsClearData());
    }, [responseExecuteReports]);
    var onBack = function () { return navigate("/reports"); };
    var onChangeFilters = function (data) {
        if (!data || Object.keys(data).length === 0)
            return;
        if (!Array.isArray(data === null || data === void 0 ? void 0 : data.dateRange) || data.dateRange.length === 0) {
            onClickMonthReport(reportDate || "");
            return;
        }
        var getDate = function (index) {
            var formatted = formattedDateYYMMDD(data.dateRange[index]);
            return ["undefined", "null", "NA"].includes(formatted) ? "" : formatted;
        };
        setState(function (prev) { return (__assign(__assign({}, prev), { bodyExeReport: __assign(__assign({}, prev.bodyExeReport), { id: reportId || "", params: {
                    from: getDate(0),
                    to: getDate(1),
                    clientId: clientId,
                } }) })); });
    };
    var onClearFilter = function () { return onClickMonthReport(reportDate || ""); };
    var onExportReport = function (i) {
        var _a;
        var formatByOptionId = (_a = {},
            _a[EXPORT_OPTION_ID.excel] = "xlsx",
            _a[EXPORT_OPTION_ID.pdf] = "pdf",
            _a);
        var exportFormat = formatByOptionId[i.id];
        if (!exportFormat)
            return;
        setState(function (prev) { return (__assign(__assign({}, prev), { exportFormat: exportFormat })); });
    };
    return {
        loading: loadingExecuteReports || loadingExport || !dataReady,
        toast: toast,
        setToast: setToast,
        columns: columns,
        rows: rows,
        htmlData: htmlData,
        reportName: state.reportName,
        onBack: onBack,
        onChangeFilters: onChangeFilters,
        onClearFilter: onClearFilter,
        onExportReport: onExportReport,
    };
};
